import React, { forwardRef, useState, useEffect } from "react";
import { Link } from "gatsby";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import settings from "../../../settings";

const proinstructors =
	`${settings.IMAGES_BASE_URL}/images/indy_images/indy-instructor-banner.jpg`;

const ProInstructors = forwardRef((props, ref) => {

  const getText = (page) => {
    if(page === 'indy') {
      return (
        <>
          <p>
            Our professional driving instructors have years of racing experience and are with you every step of the way, offering feedback and encouragement for your Indianapolis driving experience.
          </p>
          <br />
          <p>
            We practice challenge-by-choice, so you’re always at a level of performance that you feel comfortable with.
          </p>
        </>
      )
    } else {
      return ( 
        <>
          <p>
            Our professional driving instructors have years of racing experience and advanced driving skills. They’ll be with you every step of the way, from classroom sessions to on-track guidance and feedback during your speedway experience day.
          </p>
          <br />
          <p>
            We practice challenge-by-choice, so you’re always at a level of
            performance that you feel comfortable with.
          </p>
        </>
      )
    }
  }

	const [width, setWidth] = useState(null);
	useEffect(() => {
		setWidth(window.innerWidth);
		window.addEventListener("resize", handleWindowSizeChange);
		return () => {
			window.removeEventListener("resize", handleWindowSizeChange);
		};
	}, [width, setWidth]);
	const handleWindowSizeChange = () => {
		setWidth(window.innerWidth);
	};
	const isMobile = width < 1200;
	const isDesktop = width >= 1200;
	return (
		<>
			{isMobile && (
				<section className="proinstructors__mobile" ref={ref}>
					<LazyLoadImage
						effect="blur"
						src={proinstructors}
						alt="Pro Instructors Banner"
					/>
					<div className="container">
						<div className="proinstructors__content">
							<h3>Pro instructors</h3>
							{getText(props.page)}
							<Link to="/instructors">
								<button className="btn btn-bordered">
									Meet the instructors
								</button>
							</Link>
						</div>
					</div>
				</section>
			)}
			{isDesktop && (
				<section className="proinstructors" ref={ref}>
					<div className="container">
						<div className="proinstructors__content">
							<h3>Pro instructors</h3>
							{getText(props.page)}
							<Link to="/instructors">
								<button className="btn btn-bordered">
									Meet the instructors
								</button>
							</Link>
						</div>
					</div>
				</section>
			)}
		</>
	);
});

export default ProInstructors;
